import React from 'react';
import { Box, Button } from '@mui/material';
import { IconPencil } from '@tabler/icons-react';
import useColor from '../../../hooks/site/useColor';
import { Link } from 'react-router';

export default function BtnEdit({
  onEditClick,
  style,
  variantBtn = 'contained',
  variant = 1,
  iconSize = 20,
  disabled,
  ...props
}) {
  const { primary } = useColor();
  const primaryColor = primary.main;
  const customStyle = { cursor: 'pointer', ...style };

  if (variant == 1)
    return (
      <Button
        variant={variantBtn}
        disabled={disabled}
        onClick={onEditClick}
        style={customStyle}
        {...props}>
        <IconPencil height={iconSize} width={iconSize} />
      </Button>
    );

  if (variant == 2) {
    const newCustomStyle = { ...customStyle };
    if (disabled) newCustomStyle.opacity = 0.5;

    return (
      <Box onClick={onEditClick} style={newCustomStyle} {...props}>
        <IconPencil height={iconSize} width={iconSize} color={primaryColor} />
      </Box>
    );
  }
}
